import { MenuItem } from '@adaptiva/core/menus';
import { BlacklistPayload, BlacklistProperties, IMetadataObject, MetadataMenuController, MetadataObject, MetadataSerialization } from '@adaptiva/metadata/common';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { BlacklistPropertiesOverlayComponent } from '../overlays';

@Injectable()
export class AuthoringToolbarApprovingMenuController<T extends MetadataObject> extends MetadataMenuController<T> {

	public readonly blacklistMenuItemName: string = 'Blacklist Metadata';

	public override generate(_meta: T): Observable<MenuItem<T>[]> {
		if (!(_meta instanceof MetadataObject))
			_meta = this.summarize.generate<T>((_meta as IMetadataObject).javaClassName, _meta);

		return of([
			this.getMarkForUnpublicationMenuItem(_meta),
			this.getApproveDeletionMenuItem(_meta),
			this.getRejectDeletionMenuItem(_meta),
			this.getApprovePublicationMenuItem(_meta),
			this.getRejectPublicationMenuItem(_meta),
			this.getWithdrawPublicationMenuItem(_meta),
			this.getBlacklistMenuItem(_meta),
		]);
	}

	protected getBlacklistMenuItem(_object: T): MenuItem<T> {
		const _id: string = this.hashItem(this.blacklistMenuItemName, _object);
		const _menuName: string = `${this._isBlacklisted(_object) ? 'Whitelist' : 'Blacklist'} Metadata`;
		const _menuItem: MenuItem<T> = this.getItem(_id, _object) || this.createItem({
			id: _id,
			name: _menuName,
			data: _object,
			onSelect: this._handleBlacklistMenu.bind(this)
		});

		this.enableBlacklistMenuItem(_menuItem);

		return _menuItem;
	}

	protected enableBlacklistMenuItem(_menu: MenuItem<T>): void {
		const _object: T = _menu.data;
		const _isObjectBlacklisted: boolean = this._isBlacklisted(_object);

		this.authoringService.isBlacklistAllowed(!_isObjectBlacklisted, [_object]).subscribe({
			next: (_allowed: boolean) => _menu.isDisabled.next(!_allowed)
		});
	}

	private _handleBlacklistMenu(_menu: MenuItem<T>): void {
		const _object: T = _menu.data;
		const _blacklistPayload: BlacklistPayload = new BlacklistPayload({
			blacklistOrWhitelist: !this._isBlacklisted(_object),
			installableSoftwareIds: [_object.objectId]
		});

		this.overlays.create(
			BlacklistPropertiesOverlayComponent,
			{
				objectName: _object.name,
				payload: _blacklistPayload
			}
		).subscribe();
	}

	private _isBlacklisted(_object: MetadataObject): boolean {
		return MetadataSerialization.getPropertyValue<boolean, BlacklistProperties>(
			_object, BlacklistProperties.namespace, 'On'
		);
	}

}
